import '../app.css';
import WebFont from 'webfontloader';

/* fonts */
WebFont.load({
    custom: {
        families: ['Humanist531C BT:400,700,900:cyrillic,cyrillic-ext,latin-ext', 'Formular:500,900:cyrillic,cyrillic-ext,latin-ext'],
        urls: ['../css/fonts.css']
    } /* ,
    google: {
        families: ['Roboto:400,700:cyrillic']
    },*/
    /*
    typekit: {
        id: 'xxxxxx'
    }*/
});

import lazySizes from 'lazysizes';
/* lazy loading (https://github.com/aFarkas/lazysizes) */
lazySizes.init();

const lazyimages = [...document.querySelectorAll('.imageblock img')];

lazyimages.forEach(image => {
    image.addEventListener('lazyloaded', () => {
        image.parentNode.classList.add('lazycontainer');
        image.data = image.data || {};
        image.data.onLoaded = () => {
            image.parentNode.classList.add('lazyloaded');
            image.removeEventListener('lazyloaded', image.data.onLoaded);
            delete image.data.onLoaded;
        };
        image.addEventListener('lazyloaded', image.data.onLoaded);
    });
});
